<template>
  <div class="time-period-selector">
    <div class="periods-container">
      <button
        v-for="period in periods"
        :key="period.value"
        @click="selectPeriod(period.value)"
        :class="[
          'period-button',
          selected === period.value ? 'active' : ''
        ]"
      >
        {{ period.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimePeriodSelector',
  props: {
    modelValue: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      selected: this.modelValue,
      periods: [
        { label: '1D', value: 1 },
        { label: '3D', value: 3 },
        { label: '1W', value: 7 },
        { label: '2W', value: 14 },
        { label: '1M', value: 30 },
      ],
    };
  },
  watch: {
    modelValue(newVal) {
      this.selected = newVal;
    },
  },
  methods: {
    selectPeriod(value) {
      this.selected = value;
      this.$emit('period-selected', value);
    },
  },
};
</script>

<style scoped lang="scss">
  @use "@/styles/styles.scss" as *;

  .time-period-selector {
    display: flex;
    justify-content: center;

    .periods-container {
      display: inline-flex;
      border-radius: 8px;
      border: 1px solid $green;
      padding: 0;
      gap: 0;

      .period-button {
        padding: 8px 12px;
        border-radius: 0;
        border: none;
        border-right: 1px solid $green;
        background: transparent;
        color: $green;
        font-size: 0.8em;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
		font-family: 'RobotoSlab';

        &:first-child {
          border-radius: 6px 0 0 6px;
        }

        &:last-child {
          border-right: none;
          border-radius: 0 6px 6px 0;
        }

        &:hover {
          background: rgba($green, 0.08);
        }

        &.active {
          background: $green;
          color: white;
        }
      }
    }
  }
</style>
